import Echo from "laravel-echo"

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true,
});

window.echoUserListener = function(userId) { 

    //console.log("listening for Laravel Notifications");
    window.Echo.private('App.User.' + userId)
        .notification((notification) => {
            console.log("Laravel Notification recieved");
            console.log(notification);
            if(notification.type != "App\\Notifications\\SilentGlobalAlertUpdate") {

                // only add a link if one is provided
                let msgBody = 
                    `${notification.message}
                    <br />
                    <br />`;
                if(notification.link != null) {
                    msgBody += `<a href='${notification.link}'> More Info </a>`;
                }

                minerva_toastr(
                    msgBody,
                    notification.msgType,
                    notification.title,
            // { "onclick": () => window.location.href="/tasks/userview" }
                )

                if(notification.globalAlertData) {
                    updateGlobalAlertsDiv(notification.globalAlertData);
                }

            } else {
                window.updateGlobalAlertsDiv(notification.globalAlertData);
            }

            });
    /*
        .notification((notification) => {
            console.log("TicketingAlert Notification recieved");
            console.log(notification);
            minerva_toastr(
                `${notification.message}
                <br />
                <br />
                <a href='/ops/ticketing'> View Tickets</a>`,
                notification.msgType,
                notification.title,
    // { "onclick": () => window.location.href="/tasks/userview" }
            );
        });
        */

}
